// src/engine/index.ts — engine factory. A saved BYOK key flips the app from demo (Mock)
// to live (Gemini) automatically; live listen over the Live WebSocket lands in Phase 3.
import { MockEngine } from "./mock";
import { GeminiEngine } from "./gemini";
import type { TranslationEngine } from "./types";

export function createEngine(key: string): TranslationEngine {
  return key ? new GeminiEngine(key) : new MockEngine();
}

export type { TranslationEngine } from "./types";
